import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from "../screens/Login";
import { useContext } from 'react';
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import { Home } from "../screens/Home";
import { AuthContext } from '../contexts/AuthContext';
import { Users } from '../screens/Users';
import { Turns } from '../screens/turns/Turns';
import { Modules } from '../screens/turns/Modules';
import { Visualizador } from "../screens/turns/Visualizador";
import { Principal } from '../screens/Principal';
import { Channels } from '../screens/survey/admin/Channels';
import { Services } from '../screens/survey/admin/Services';
import { Questions } from '../screens/survey/admin/Questions';
import { Surveys } from '../screens/survey/admin/Surveys';
import { Survey } from '../screens/Survey';
import { QuantiumSettings } from '../screens/settings/QuantiumSettings';
import { Responses } from '../screens/survey/admin/Responses';
import { QuantiumExtractions } from '../screens/extractions/QuantiumExtractions';
import { TailExtractions } from '../screens/extractions/TailExtractions';
import { Assets } from '../screens/assets/Assets';
import { InactiveAssets } from '../screens/assets/InactiveAssets';
import { Asset } from '../screens/assets/Asset';

export const AppRouter = () => {

    const { usuario } = useContext(AuthContext);

    return (
        <Routes>
            <Route path='/visualizador/:id' element={ <Visualizador /> } />
            <Route path='/encuesta/:id' element={ <Survey /> } />
            <Route path='/activo/:id' element={ <Asset /> } />
            <Route index path="/login" element={ <PublicRoute isLogged={ usuario }><Login /></PublicRoute> } />
            <Route path="/home" element={ <PrivateRoute isLogged={ usuario }><Home /></PrivateRoute> }>
                <Route index path="/home" element={ <Principal /> } />
                <Route path='usuarios' element={ <Users /> } />
                {/*Turnos*/}
                <Route index path='turnos/:id' element={ <Turns /> } />
                <Route index path='modulos/:sede' element={ <Modules /> } />
                {/*Encuestas*/}
                <Route index path='canales' element={ <PrivateRoute isLogged={usuario}><Channels /></PrivateRoute> } />
                <Route index path='servicios' element={ <PrivateRoute isLogged={usuario}><Services /></PrivateRoute> } />
                <Route index path='preguntas' element={ <PrivateRoute isLogged={usuario}><Questions /></PrivateRoute> } />
                <Route index path='encuestas' element={ <PrivateRoute isLogged={usuario}><Surveys /></PrivateRoute> } />
                <Route index path='respuestas' element={ <PrivateRoute isLogged={usuario}><Responses /></PrivateRoute> } />
                {/*Activos*/}
                <Route index path='activos' element={ <PrivateRoute isLogged={usuario}><Assets /></PrivateRoute> } />
                <Route index path='inactivos' element={ <PrivateRoute isLogged={usuario}><InactiveAssets /></PrivateRoute> } />
                {/*Extracciones*/}
                <Route index path='extracciones/turnA' element={ <PrivateRoute isLogged={usuario}><TailExtractions /></PrivateRoute> } />
                <Route index path='extracciones/opinA' element={ <PrivateRoute isLogged={usuario}><QuantiumExtractions /></PrivateRoute> } />
                {/*Ajustes*/}
                <Route index path='ajustes/opinA' element={ <PrivateRoute isLogged={usuario}><QuantiumSettings /></PrivateRoute> } />
            </Route>
            <Route path='*' element={ <Navigate to='/login' /> }  />
        </Routes>
    );
}